// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-search_container__HPew6","title":"empty-search_title__ezafx"};